import { useState } from 'react'
import { SUPPORTED_CITIES } from './constants'
import { PostHogEvent, posthog } from '~/client/common/posthog'

interface UnsupportedCityAlertProps {
  cityName: string | undefined
  onDismiss: () => void
  entityCityNames?: string[]
}

export function UnsupportedCityAlert({ cityName, onDismiss, entityCityNames }: UnsupportedCityAlertProps) {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [showCities, setShowCities] = useState(false)

  const handleNotify = () => {
    if (!email) return
    setSubmitted(true)
    try {
      posthog?.capture?.(PostHogEvent.CITY_EXPANSION_REQUESTED, {
        email,
        city_name: cityName || 'Unknown',
      })
    } catch (err) {
      console.error('[Revel Street] Failed to capture city expansion PostHog event:', err)
    }
  }

  return (
    <div className="mt-2 rounded-[10px] border border-orange-200 bg-orange-50 px-4 py-3.5">
      {!submitted ? (
        <>
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="mb-0.5 text-[13px] font-semibold text-orange-900">
                We're not in {cityName || 'that city'} yet
              </div>
              <div className="text-xs leading-relaxed text-orange-700">
                We cover the biggest US corporate event markets. Want us to notify you when we expand?
              </div>
            </div>
            <button
              onClick={onDismiss}
              className="border-none bg-transparent text-lg leading-none text-orange-700 hover:opacity-70"
            >
              ×
            </button>
          </div>
          <div className="mt-2.5 flex gap-2">
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="recs-input flex-1 rounded-[7px] border border-orange-200 bg-white px-3 py-[7px] font-inherit text-[13px] text-gray-900"
            />
            <button
              onClick={handleNotify}
              className="whitespace-nowrap rounded-[7px] border-none bg-orange-600 px-3.5 py-[7px] font-inherit text-xs font-semibold text-white hover:bg-orange-700"
            >
              Notify me
            </button>
          </div>
          <div>
            <button
              onClick={() => setShowCities(!showCities)}
              className="mt-2 border-none bg-transparent cursor-pointer text-[11px] text-orange-900 underline hover:opacity-70 p-0 font-inherit"
            >
              See all supported cities {showCities ? '▲' : '▼'}
            </button>
            {showCities && (
              <div className="mt-1.5 flex flex-wrap gap-1">
                {(entityCityNames && entityCityNames.length > 0 ? entityCityNames : Object.keys(SUPPORTED_CITIES)).map((city) => (
                  <span
                    key={city}
                    className="rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-medium text-orange-800"
                  >
                    {city}
                  </span>
                ))}
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="flex items-center gap-2">
          <div className="flex h-[22px] w-[22px] items-center justify-center rounded-full bg-orange-200 text-[11px]">
            ✓
          </div>
          <div className="text-[13px] text-orange-900">
            You're on the list. We'll reach out when we launch there.
          </div>
        </div>
      )}
    </div>
  )
}
